import { telaSobDemanda } from '../../nucleo/paginas/TelaSobDemanda';
import { Link } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../../nucleo/api';
import type { ModuloWeb } from '../../nucleo/modulos';
import { pode, useSessao } from '../../nucleo/sessao';
import { CartaoIndicador } from '../../nucleo/ui/Estados';
import { dicionario } from './i18n';
import { AcaoNovo } from './Comum';

/** F10: indicador do Início com os cursos do usuário em andamento (CartaoIndicador do núcleo, §7.13: erro com traço e "Tentar de novo"). */
function Indicadores() {
  const { t } = useTranslation('treinamento');
  const q = useQuery({ queryKey: ['treinamento', 'indicadores'], queryFn: () => api<{ vinculado: boolean; em_andamento: number; concluidos: number; percentual_medio: number }>('/api/v1/treinamento/indicadores') });
  return (
    <CartaoIndicador
      rotulo={t('indicadores.emAndamento')}
      valor={q.data?.em_andamento}
      consultas={[q]}
      detalhe={
        q.data && (
          <Link to="/treinamento/cursos" className="mt-1 inline-block text-xs text-tinta-3 hover:text-acento-texto hover:underline">
            {q.data.vinculado ? t('indicadores.medio', { p: q.data.percentual_medio }) : t('indicadores.semVinculo')}
          </Link>
        )
      }
    />
  );
}

/** Botão da aba conforme o papel (criar curso, trilha ou matrícula). */
function acao(permissao: string, rotulo: string) {
  return function Acao() {
    const eu = useSessao();
    return pode(eu, permissao) ? <AcaoNovo rotulo={rotulo} /> : null;
  };
}

const carregar0 = () => import('./Cursos');
const carregar1 = () => import('./FichaCurso');
const carregar2 = () => import('./Assistir');
const carregar3 = () => import('./Trilhas');
const carregar4 = () => import('./Progresso');
const carregar5 = () => import('./Certificado');

const Cursos = telaSobDemanda(carregar0, 'Cursos');
const FichaCurso = telaSobDemanda(carregar1, 'FichaCurso');
const Assistir = telaSobDemanda(carregar2, 'Assistir');
const Trilhas = telaSobDemanda(carregar3, 'Trilhas');
const Progresso = telaSobDemanda(carregar4, 'Progresso');
const Certificado = telaSobDemanda(carregar5, 'Certificado');

export const modulo: ModuloWeb = {
  slug: 'treinamento',
  menu: 'treinamento',
  dicionario,
  abas: [
    { rotulo: 'abas.cursos', caminho: 'cursos', elemento: <Cursos />, Acao: acao('treinamento.criar', 'acoes.novoCurso'), ordem: 1 },
    { rotulo: 'abas.trilhas', caminho: 'trilhas', elemento: <Trilhas />, Acao: acao('treinamento.criar', 'acoes.novaTrilha'), ordem: 2 },
    { rotulo: 'abas.progresso', caminho: 'progresso', elemento: <Progresso />, Acao: acao('treinamento.criar', 'acoes.matricular'), ordem: 3 },
  ],
  rotas: [
    { path: 'treinamento/cursos/:id', element: <FichaCurso /> },
    { path: 'treinamento/assistir/:curso', element: <Assistir /> },
    { path: 'treinamento/assistir/:curso/:aula', element: <Assistir /> },
    { path: 'treinamento/certificados/:codigo', element: <Certificado /> },
  ],
  Indicadores,
};
